import { render, staticRenderFns } from "./BattleItem.vue?vue&type=template&id=76655eee&scoped=true&"
import script from "./BattleItem.vue?vue&type=script&lang=ts&"
export * from "./BattleItem.vue?vue&type=script&lang=ts&"
import style0 from "./BattleItem.vue?vue&type=style&index=0&id=76655eee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76655eee",
  null
  
)

export default component.exports